<template>
  <div
    class="sensor-status"
    :class="{
      'sensor-status-online': online,
      'sensor-status-offline': !online,
    }"
  >
    <div class="sensor-status-icon"></div>
    <template v-if="online">Online</template>
    <template v-else>Offline</template>
  </div>
</template>

<script setup lang="ts">
defineProps({
  online: { type: Boolean, required: false, default: false },
});
</script>

<style lang="scss">
.sensor-status {
  @include mixins.flex-center($horiz: flex-start, $gap: variables.$vantage-base-sizing-xxs);
}

.sensor-status-icon {
  background: variables.$vantage-base-primitives-color-tertiary-200;
  border-radius: 50%;
  height: variables.$vantage-base-sizing-xxs;
  width: variables.$vantage-base-sizing-xxs;
}

.sensor-status-online .sensor-status-icon {
  background: variables.$vantage-base-primitives-color-green-200;
}
</style>
